import _extends from "@babel/runtime/helpers/esm/extends";
import { useIsLandscape } from '../useIsLandscape';
/**
 * Prepare the props for the view layout (managed by `PickersViewLayout`)
 */
export const usePickerLayout = ({
  props,
  propsFromPickerValue,
  propsFromPickerViews,
  wrapperVariant
}) => {
  const {
    orientation
  } = props;
  const isLandscape = useIsLandscape(propsFromPickerViews.views, orientation);
  const layoutProps = _extends({}, propsFromPickerViews, propsFromPickerValue, {
    isLandscape,
    wrapperVariant,
    disabled: props.disabled,
    readOnly: props.readOnly,
    showToolbar: props.showToolbar
  });
  return {
    layoutProps
  };
};